/* DN (Sentry DE-1VF, Vorbild US-1Y): jQuery-Ajax als Promise mit Fangnetz. Ein 422 von /cart/update.js
   ("Parameter updates ist ungueltig", ausgeloest durch leere Keys im color-array) lief vorher als
   unbehandelte Promise-Ablehnung durch. Der error-Callback im Aufruf bleibt, die Ablehnung wird hier zu null. */
window.dnAjaxSicher = window.dnAjaxSicher || function (dnOptionen) {
  return $.ajax(dnOptionen).catch(function () { return null; });
};
window.dnGetJsonSicher = window.dnGetJsonSicher || function (dnUrl, dnErfolg) {
  return $.getJSON(dnUrl, dnErfolg).catch(function () { return null; });
};
document.addEventListener("DOMContentLoaded", function () {

function formatExpandedItemsToJsonArray(items) {
  const jsonArray = items.map(item => ({
    id: `gid://shopify/ProductVariant/${item.id}`,
    quantity: 1,
    customKey: item.price,
    isOptional: item.optional
  }));
  return JSON.stringify(jsonArray);
}


function generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

async function addRelated(variantIdArray, $that, optionalIndex) {
    let optionalIndexInt = optionalIndex.map(function(str) { return parseInt(str) });
    let set_id = generateUID();

    let reduced_obj = variantIdArray.reduce(function(obj, b) {
        obj[b] = ++obj[b] || 1;
        return obj;
    }, {});

    let indexedObj = {};

    for (let i = 0; i < variantIdArray.length; i++) {
        indexedObj[i] = variantIdArray[i];
    }

    var product_data = [];
 
    let child_variant_ids = "";
    let free_variant_ids = "";
  
    Object.keys(reduced_obj).forEach((key, index) => {
        if (index != 0) {
            if (!child_variant_ids.includes(key)) {
                child_variant_ids += key + ":" + reduced_obj[key];
                child_variant_ids += '__';
            }
        }
    });



  let expandedItems =   [];
  
    $('.hidden-color[value!=""]').each(function(index) {
            expandedItems.push(parseInt($(this).attr('variant-id')));
        });
    $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
        const priceVar = parseInt($(this).attr('data-original-price'), 10) / 100;
        const variantId = parseInt($(this).attr('variant-id'), 10);
        let isOptional = false;
        if ($(this).hasClass('optional-switcher')) {
            isOptional = true;
        }

        expandedItems.push({ id: variantId, price: priceVar, optional: isOptional });
        
        if (free_variant_ids === "") {
            free_variant_ids = `${variantId}`;
        } else {
            free_variant_ids += `,${variantId}`;
        }
    });

    const expandJSON = formatExpandedItemsToJsonArray(expandedItems);
    console.log(expandJSON);
  
    $('.remover_upsell:checked').each(function() {
        child_variant_ids += parseInt($(this).val()) + ":" + 1;
        child_variant_ids += '__';
    });

    $('.optional_accessories_block_product_item.coladded').each(function() {
        child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
        child_variant_ids += '__';
    });

    $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
        child_variant_ids += '__';
      }
    });

  $('.free_product_hidden').each(function() {
        child_variant_ids += parseInt($(this).val()) + ":" + 1;
        child_variant_ids += '__';
  });


    for (let key in indexedObj) {
        if (indexedObj.hasOwnProperty(key)) {
            if (key == 0) {
                let props = {};
                props['_starter-set-parent'] = true;
                props['_bundle-parent'] = true;
              if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
              if(window.atcPrice != undefined) props['_starter-price'] = window.atcPrice;
                props['_set'] = set_id;
                props['_variants_set'] = child_variant_ids;
                props['_childItemsJson'] = expandJSON;
                props['_free_variants'] = free_variant_ids;
                let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
                product_data.push(prod);
            }
        }
    }

    // for (let key in indexedObj) {
    //     if (indexedObj.hasOwnProperty(key)) {
    //         if (key == 0) {
    //             let hiddenColorArray = $('.hidden-color[value!=""]');
    //             if (hiddenColorArray.length > 0) {
    //                 let props = {};
    //                 $('.hidden-color[value!=""]').each(function(index) {
                  
    //                     var color_string = "_Farbe_Img " + (index + 1);
    //                     props[color_string] = $(this).attr('variant-img');
    //                 });
    //                 props['_bundle-parent'] = true;
    //                 props['_set'] = set_id;
    //               if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
    //                 props['_variants_set'] = child_variant_ids;
    //                 props['_childItemsJson'] = expandJSON;
    //                 props['_free_variants'] = free_variant_ids;
    //                 let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
    //                 product_data.push(prod);
    //             }
    //             let hiddenColorArray2 = $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded');
    //             if (hiddenColorArray2.length > 0) {
    //                 let props2 = {};
    //                 $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
    
    //                     var color_string = "_Farbe_Img " + (index + 1);
    //                     props2[color_string] = $(this).attr('variant-img');
    //                     var color_name= "_Farbe_Name " + (index + 1);
    //                     props2[color_name] = $(this).attr('variant-name');
    //                 });
    //                 props2['_bundle-parent'] = true;
    //                 props2['_set'] = set_id;
    //               if(window.atcPriceCompare != undefined) props2['_compareOriginalPrice'] = window.atcPriceCompare;
    //                 props2['_variants_set'] = child_variant_ids;
    //                 props2['_childItemsJson'] = expandJSON;
    //                 props2['_free_variants'] = free_variant_ids;
    //                 let prod2 = { quantity: 1, id: parseInt(indexedObj[key]), properties: props2 };
    //                 product_data.push(prod2);
    //             }
    //         } else {
    //             let optionalFound = false;
    //             let originalPriceOptional;
    //             let prod = { quantity: 1, id: parseInt(indexedObj[key]) };
    //             $('.color-selection__grid-item.optional-switcher color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
    //                 let varId = parseInt($(this).attr('variant-id'));
    //                 if (parseInt(indexedObj[key]) == varId && optionalIndexInt.includes(parseInt(key))) {
    //                     let optionalQty = 0;
    //                     $('.color-selection__grid-item.optional-switcher color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
    //                         let varIdInner = parseInt($(this).attr('variant-id'));
    //                         if (varId === varIdInner) {
    //                             optionalQty = optionalQty + 1;
    //                             originalPriceOptional = parseFloat($(this).attr('data-original-price') / 100);
    //                         }
    //                     });
                      
    //                   let offAmount = parseFloat($(this).attr('data-percent'));
    //                   if (originalPriceOptional) {
    //                     let optionalPercentOff = parseInt($('#pick-color-id').attr('data-optional-off'));
    //                     offAmount = originalPriceOptional * (optionalPercentOff / 100);
    //                   }
    //                     prod["properties"] = {
    //                         '_bundled-product': true,
    //                         '_bundled-product-discount': true,
    //                         '_discountAmount': offAmount,
    //                         '_set_id': set_id,
    //                         '_baseQty': optionalQty
    //                     };
    //                     optionalFound = true;
    //                     return false;
    //                 }
    //             });
    //             if (!optionalFound) {
    //                 let freeQty = 0;
    //                 $('.color-selection__grid-item.required-switcher color-switcher.color-selection__image.required-switcher.coladded').each(function(index) {
    //                     let varIdInner = parseInt($(this).attr('variant-id'));
    //                     if (parseInt(indexedObj[key]) === varIdInner) {
    //                         freeQty = freeQty + 1;
    //                     }
    //                 });
    //                 prod["properties"] = {
    //                     '_bundled-product': true,
    //                     '_bundled-free': true,
    //                     '_set_id': set_id,
    //                     '_baseQty': freeQty
    //                 }
    //             }
              
    //             product_data.push(prod);
    //         }
    //     }
    // }

    $('.remover_upsell:checked').each(function() {
        let upsell_prod = { quantity: 1, id: parseInt($(this).val()) };
        upsell_prod["properties"] = {
            '_bundled-product': true,
            '_discountAmount': parseFloat($(this).attr('discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod);
    });

    $('.optional_accessories_block_product_item.coladded').each(function() {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_discountAmount': parseFloat($(this).attr('data-discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
    });

    $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_bundled-free': true,
            '_discountAmount': parseFloat($(this).attr('data-discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
      }
    });

    $('.free_product_hidden').each(function() {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).val()) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_bundled-free': true,
            '_discountAmount': parseFloat($(this).attr('data-discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
    });

    console.log(product_data);

    async function addItemsToCartAndProceed() {
        try {
            /* 2026-10-12: ohne Designs keine Elternzeile. Die Cart-Transform-Funktion legt die Kinder der Bestellung
               nur aus _childItemsJson an; ein Set ohne diese Liste kommt als Set ohne Designs an (#DN1502169).
               Vor dem Senden pruefen; der catch unten gibt den Knopf zurueck und zeigt die Meldung. */
            var dnWaisenEltern = product_data[0] && product_data[0].properties;
            var dnWaisenKinder = [];
            try { dnWaisenKinder = JSON.parse((dnWaisenEltern && dnWaisenEltern._childItemsJson) || '[]'); } catch (dnWaisenFehler) { dnWaisenKinder = []; }
            if (!Array.isArray(dnWaisenKinder)) dnWaisenKinder = [];
            dnWaisenKinder = dnWaisenKinder.filter(function (k) { return k && /ProductVariant\/\d+$/.test(String(k.id)); });
            if (!dnWaisenEltern || !dnWaisenKinder.length) {
                throw new Error(window.dnSetText ? window.dnSetText('zuerst') : 'Bitte wähle zuerst deine Designs.');
            }
            if (window.DnAtcSource) window.DnAtcSource.stamp(product_data, null, window.DnAtcSource.templateLabel());
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            // After all items are added, proceed to the next step
            if ($('body').hasClass('direct_checkout_pd')) {
                window.location.href = '/checkout';
            } else {
                setTimeout(function() {
                    $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
                }, 200);

                fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    /* Sentry US-3F (2026-09-15): Section-Antwort ohne #mini-cart (Bot-/Fehlerseite) -> nichts tun statt TypeError */
                    const quelleBox = html.querySelector("#mini-cart"), zielBox = document.querySelector('#mini-cart');
                    if (quelleBox && zielBox) zielBox.innerHTML = quelleBox.innerHTML;
                })

                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();

                  if(!window.upsellPopupActive){
                    
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: {
                            cart: cartContent
                        }
                    }));

                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                        }
                    }));
                  }else{
                     window.upsellPopupFunc(cartContent, $that);
                  }

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              
                $('.loader-button__text').show();
                $('.loader-button__loader').hide();
                $('.inventory-product[aria-busy]').removeAttr('aria-busy');
            }

            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
        } catch (error) {
            /* 2026-09-14: Knopf zurueckgeben - nach einem Fehler blieb er sonst im Ladezustand haengen */
            $('.loader-button__text').show();
            $('.loader-button__loader').hide();
            $('.inventory-product[aria-busy]').removeAttr('aria-busy');
            $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
        }
    }

    // Call the function to add items to the cart and proceed
    addItemsToCartAndProceed();
}

$(document).ready(function() {
  
$('body').on('click', '.inventory-product', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).find('.loader-button__text').hide();
    $(this).find('.loader-button__loader').show();
    /* 2026-09-14: aria-busy dazu - die Sticky-Leiste (dn-set-sticky-cta) spiegelt es und dreht mit */
    $(this).attr('aria-busy', 'true');

    $('#MainPaymentContainer').attr('disabled', 'disabled').addClass('disabled');

    const $that = this;

    /* 2026-10-12: keine Designs gewaehlt, gar nicht erst anfangen. Sonst raeumt updateProduct unten den alten
       Satz aus dem Warenkorb, und die Pruefung vor dem Senden (addItemsToCartAndProceed) bricht danach ab. */
    if (!$('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').length) {
        $(this).find('.loader-button__text').show();
        $(this).find('.loader-button__loader').hide();
        $(this).removeAttr('aria-busy');
        $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
        $that.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: { status: "error", error: window.dnSetText ? window.dnSetText('zuerst') : 'Bitte wähle zuerst deine Designs.' }
        }));
        return;
    }

    if ($(this).hasClass('updateProduct')) {
        const pre_set_id = $(this).attr('set-id'); // Get the pre_set_id
        let keysToRemove = []; // Array to store keys of items to be removed

        // Get the cart data
        await window.dnGetJsonSicher(`${window.themeVariables.routes.cartUrl}.js`, function (cart) {
            const items = cart.items;

            // Iterate through each cart item
            items.forEach((item) => {
                // Check for the _set_id or _set property
                if ((item.properties && item.properties._set_id === pre_set_id) ||
                    (item.properties && item.properties._set === pre_set_id)) {
                    keysToRemove.push(item.key); // Store the item's key
                }
            });
        });

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    } else if ($(this).hasClass('updateSingleProducts')) {
  
        const pre_set_id = $(this).attr('color-array');
        let keysToRemove = (pre_set_id?.split(',') || []).map(function (dnKey) { return dnKey.trim(); }).filter(Boolean); /* DN: leere Keys ergeben ein 422 */
      
        $(this).attr('color-array', '');
        $(this).removeClass('updateSingleProducts')

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    }

    // Collect other items
    let items = [];
    let itemsOptionalIndex = [];

        items.push(parseInt($('.product-form__buy-buttons input[name="id"]').val()));


        $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
            items.push(parseInt($(this).attr('variant-id')));
            itemsOptionalIndex.push(items.length - 1);
        });

  /* free nail oil patch */
 
     if ($('body').hasClass('addFreeNailOil')) {
            items.push(39520435142843);
        }
        if ($('body').hasClass('addFreePrimer')) {
            items.push(42724339351739);
        }
        if ($('body').hasClass('addFreeEntfernerBasics')) {
            items.push(46799604515154);
        }

  addRelated(items, $that, itemsOptionalIndex);
  
  console.log(items);
  
});
  
});

}); // DOMContentLoaded end here